import React, { useEffect, useState } from 'react';
import { Question } from '../types';
import { useAppDispatch, useAppSelector } from '../store/store';
import { updateQuestionResponse } from '../store/features/CompleteSurveySlice';
import QuestionResponseContainer from './QuestionResponseContainer';

interface ScalePreviewDisplayProps {
    question: Question;
    questionText: string;
    questionBody: {
        min: number;
        max: number;
        step: number;
    };
}

const ScalePreviewDisplay: React.FC<ScalePreviewDisplayProps> = ({ question, questionText, questionBody }) => {

    const [value, setValue] = useState(0);
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);

    useEffect(() => {
        dispatch(updateQuestionResponse({questionId:question.id, response:value}))
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(parseInt(e.target.value, 10));
    };

    return (
        <QuestionResponseContainer question={question}>
            <div className="flex justify-center items-center mt-6">
                <input
                    type="range"
                    min={questionBody.min}
                    max={questionBody.max}
                    step={questionBody.step}
                    value={value}
                    onChange={handleChange}
                    className="w-full custom-slider"
                />
                <div className={`flex justify-center items-center ml-10 ${value <= 0 ? 'bg-stone-500' : 'bg-[#3da8e2]'} w-20 px-4 py-4 rounded-xl`}>
                    <p className='text-white text-2xl font-BCBold'>{value}</p>
                </div>
            </div>
        </QuestionResponseContainer>
    );
};

export default ScalePreviewDisplay;